import { ReactNode } from 'react';

import { CasAccountType } from './app';

/*
 * @Description:
 */
export interface RootState {
  counter: any;
}

export interface MenuOption {
  key: string;
  value: string;
  isDefault?: boolean;
}

export interface ClpAccount {
  groupCompanyGuid: string;
  userDisplayname: string;
}

export interface MultiTenant {
  isRoot: boolean;
  displayName: string;
  groupCompanyGuid: string;
}

export interface BreadCrumbInfo {
  breadCrumb: string;
  router: string;
}

export interface LoginUser {
  accountType: CasAccountType;
  accountName: string;
  accountEmail: string;
  loginName: string;
  loginEmail: string;
  preference: string;
  roleName: string;
  groupCompanyGuid: string;
  clpCompanyId: string;
}

export interface MultiTenantsReqDto {
  isRoot: boolean;
  toClpAccountName: string;
  multiTenantEmail: string;
  toClpGroupCompanyGuid: string;
}

export interface ServiceType {
  id: number;
  name: ServiceNameEnum;
}

export enum LicenseType {
  TMCAS,
  TMCASSF,
  // 'TMCAS-XDR-ADDON',
}

export enum DashboardSectionKey {
  Total = 'total_detections',
  Ransomware = 'ransomware',
  BEC = 'bec',
  Summary = 'summary',
  SecurityRisk = 'atp_srs',
  VA = 'atp_va',
  DLP = 'dp',
  Quishing = 'quishing',
  Scam = 'scam',
}

export type DashboardSection = {
  [key in DashboardSectionKey]: boolean;
};

export type SeverityEnum = 'success' | 'warning' | 'info' | 'error';
export type PositionEnum =
  | 'top'
  | 'top-left'
  | 'top-right'
  | 'bottom'
  | 'bottom-left'
  | 'bottom-right';

export interface ToastProps {
  position?: PositionEnum;
  duration?: number;
  severity: SeverityEnum;
  titleMsg: string;
  bodyMsg?: ReactNode;
  error?: ErrorInfo;
}

export interface ErrorInfo {
  status: number;
  data: {
    error: {
      code: string;
      message: string;
    };
    traceId: string;
  };
}
export interface Alert {
  message: string;
  severity: SeverityEnum;
  isClosable?: boolean;
  icon?: string;
}

export interface GlobalSettingFeatureShow {
  [key: string]: boolean | number;
}

export interface NotificationEmailSettingsResDto {
  signatureContent: {
    content: string;
    enabledStatus: boolean;
  };
  senderDisplayName: {
    content: string;
    enabledStatus: boolean;
  };
}

export interface NotificationEmailSettingsItem {
  content: string;
  enabledStatus: boolean;
}

export enum Region {
  UAE = 'uaenorth',
}

export enum ServiceNameEnum {
  Exchange = 'exchange',
  SharePoint = 'sharepoint',
  OneDrive = 'onedrive',
  Dropbox = 'dropbox',
  GoogleDrive = 'googledrive',
  Box = 'box',
  Gmail = 'gmail',
  GmailInline = 'gmail_inline',
  Teams = 'teams',
  TeamsChat = 'teams_chat',
  ExchangeServer = 'exchangeserver',
  SalesforceSandbox = 'salesforce_sandbox',
  SalesforceProduction = 'salesforce_production',
  ExchangeInline = 'exchange_inline',
  MicrosoftIdentityProtection = 'microsoft_identity_protection',
  MicrosoftInformationProtection = 'microsoft_information_protection',
}
export enum PolicySubTypeEnum {
  inbound = 0,
  outbound = 1,
}

export interface ValidProps {
  validMethod: (value: string) => boolean | Promise<boolean>;
  errMsg: string;
}

export enum PromiseResult {
  Fulfilled = 'fulfilled',
  Rejected = 'rejected',
}

export interface WhatsNewPreferences {
  whatsNewDisabled: boolean;
  olhVersion: string;
}
